import React from 'react';
import { Card, Space, Typography, Button } from 'antd';
import { AddRounded } from '@mui/icons-material';

const ImageCard = ({
  imgUrl,
  title,
  description,
  action,
    onClick,
  cardClassName = 'mb-4 gapless-x',
  imgHeight = '240px',
  imgBorderRadius = 4,
    maxRows=4,
    imageOnly=false
}) => {
  return (
    <Card
      className={cardClassName}
      hoverable
      onClick={onClick}
      cover={
        <img
          className={'shadow-sm'}
          alt={title}
          src={imgUrl}
          style={{ height: imgHeight, objectFit: 'cover', borderRadius: imgBorderRadius }}
        />
      }
      bordered={false}
    >
      {!imageOnly && (
          <Space className={'mt-3'} direction={'vertical'} style={{ width: '100%' }} size={'large'}>
            <Space direction={'vertical'}>
              <Typography.Text style={{ fontSize: '15px', fontWeight: 600 }}>{title}</Typography.Text>
              <Typography.Paragraph ellipsis={{rows: maxRows}} style={{
                fontWeight: '500', color: 'rgba(0,0,0,0.6)', fontSize: '12px',
                maxHeight: `${maxRows}rem`
              }}>
                {description}
              </Typography.Paragraph>
            </Space>
            {action}
          </Space>
      )}
    </Card>
  );
};

export default ImageCard;